var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');

module.exports = function() {
    var marker = new Marker('integration');

    new Deletism(marker);
    new Undeletism(marker);

    $('.filtertron').filtertron('integrations', {
        expander: '#filtertronExpander'
    });
};
